import { logger } from "./logger";

export function initShopifyEditor() {
  if (!window.Shopify?.designMode) return;

  logger.info("Theme", "Shopify editor mode");
}
